import * as React from 'react';
import styled from 'styled-components';
import Doodle404 from '../../styles/custom-icons/doodles/404';
import { DefaultButton } from '../../styles/global/css/GlobalButton';
import { PastelPrimaryColor } from '../../styles/global/css/Utils';
import { Translate } from '../../styles/global/translate';

function NotFound() {
	return <NotFoundWrapper>
		<Title><Translate id='404Message' /></Title>
		<GoBackButton onClick={() => window.location.href = '/'}><Translate id='backToHome' /></GoBackButton>
		<OopsWrapper>
			<Doodle404 width='100%' height='100%' />
		</OopsWrapper>
	</NotFoundWrapper>;
}

const GoBackButton = styled(DefaultButton)`
	font-size: clamp(2rem, 2vmin, 2rem);
	height: unset;
	line-height: unset;
	margin-left: 50px;

`;

const NotFoundWrapper = styled.div`
	position: relative;
	height: 100dvh;
	overflow: hidden;
	background: ${PastelPrimaryColor};
`;

const Title = styled.h1`
	position: relative;
	z-index: 1;
	margin: 0;
	padding: 50px;
	max-width: 15ch;
	font-size: clamp(7rem, 8vmin, 7rem);
	line-height: 1.05;
`;

// The doodle's viewBox is 216x170: size it from whichever viewport side is limiting,
// and let it bleed slightly off the bottom-right corner
const OopsWrapper = styled.div`
	position: absolute;
	right: 0;
	bottom: 0;
	translate: 33% 33%;
	width: min(110vw, 110vh * 216 / 170);
	aspect-ratio: 216 / 170;

	@media (min-width: 768px) {
		width: min(75vw, 90vh * 216 / 170);
	}
`;

export default NotFound;
